export default "__VITE_ASSET__BUIyfuxu__"